module.exports = __webpack_public_path__ + "static/media/visa.40a24129.png";